module.exports = __webpack_public_path__ + "img/hdp-1.2d7b1f40.jpeg";